<template> </template>

<script>
export default {
  async asyncData({ params }) {
    Array.prototype.sum = function(params) {
      var total = 0
      for (var i = 0, _len = this.length; i < _len; i++) {
        total += this[i][params]
      }
      return total
    }
  }
}
</script>
